module.exports = __webpack_public_path__ + "img/full-harpies-1.9573faad.jpg";